export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(amount || 0);

export const formatNumber = (num) =>
  new Intl.NumberFormat().format(Math.round(num || 0));

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
};

export const formatTimestamp = (ts) => {
  if (!ts) return 'N/A';
  const date = typeof ts === 'number' ? new Date(ts * 1000) : new Date(ts);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const riskTone = (level = '') => {
  const l = String(level).toLowerCase();
  if (l === 'critical' || l === 'high') return 'high';
  if (l === 'medium') return 'medium';
  return 'low';
};

export const riskRatioTone = (ratio = 0) => {
  if (ratio >= 50) return 'high';
  if (ratio >= 25) return 'medium';
  return 'low';
};

export const frequencyLabel = (riskDetections = 0) => {
  if (riskDetections >= 10) return { label: 'Frequent', tone: 'high' };
  if (riskDetections >= 3) return { label: 'Moderate', tone: 'medium' };
  return { label: 'Rare', tone: 'low' };
};

export const costTone = (cost = 0) => {
  if (cost > 1) return 'high';
  if (cost > 0.1) return 'medium';
  return 'low';
};
